import React, { ReactNode } from 'react'
import './LensSidebarFooter.scss'

export const LensSidebarFooter = ({ children }: { children: ReactNode }) => (
  <div className="LensSidebarFooter">{children}</div>
)
